// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import './WorldClock.css';
import timezoneMeta from '../data/timezone-meta.json';
import AnalogClock from './AnalogClock';

const WorldClock = () => {
  // Native Place (Chennai, India)
  const [time, setTime] = useState(moment().tz("Asia/Kolkata"));

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(moment().tz("Asia/Kolkata"));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTimeWithSeconds = (momentObj) => {
      const hhmm = momentObj.format('hh:mm');
      const ss = momentObj.format('ss');
      const a = momentObj.format('A');
      
      return (
          <>
            {hhmm}<span className="seconds-part">:{ss}</span> <span className="seconds-part">{a}</span>
          </>
      );
  };
  
  const formatTimeWithSecondsSmall = (momentObj) => {
    const hmm = momentObj.format('h:mm');
    const ss = momentObj.format('ss');
    const a = momentObj.format('A');
    
     return (
          <>
            {hmm}<span className="seconds-part-small">:{ss}</span> <span className="seconds-part-small">{a}</span>
          </>
      );
  };

  const nativeDate = time.format('ddd, MMM D');
  const nativeLocation = "Chennai, India";

  // Selected locations to display
  const worldLocations = [
    { code: 'US', zone: 'America/New_York', label: 'New York' },
    { code: 'FR', zone: 'Europe/Paris', label: 'Paris' },
    { code: 'JP', zone: 'Asia/Tokyo', label: 'Tokyo' },
    { code: 'AU', zone: 'Australia/Sydney', label: 'Sydney' },
  ];

  return (
    <div className="world-clock-container bg-[#8A7650] backdrop-blur-[20px] border-[5px] border-[#B6AE9F] text-white rounded-[20px] p-5 w-full min-w-[520px] max-w-[980px] box-border font-['Courier_New',Courier,monospace] relative overflow-hidden flex flex-col max-[767px]:min-w-0 max-[767px]:max-w-full max-[767px]:rounded-[16px] max-[767px]:p-4" id="world-clock">
      <div className="world-clock-content flex flex-row gap-[30px] relative z-[1] w-full max-[767px]:flex-col max-[767px]:gap-5">
          {/* Left Column: Native Clock + Analog Clock */}
          <div className="clock-left-column flex-1 flex flex-col justify-between min-w-[280px] max-[767px]:min-w-0">
            {/* Main Clock (Native Place) */}
            <div className="main-clock mb-[15px] relative z-[1]">
                <div className="main-clock-display">
                     <div className="digital-clock text-[2.5rem] font-[700] leading-[1] tracking-[2px] mb-2 flex items-baseline gap-1.25">
                        {formatTimeWithSeconds(time)}
                     </div>
                </div>
                <div className="main-clock-details flex justify-between text-[0.9rem] opacity-80 uppercase tracking-[1px] gap-2.5">
                  <span className="main-clock-location">{nativeLocation}</span>
                  <span className="main-clock-date">{nativeDate}</span>
                </div>
            </div>

            {/* Analog Clock */}
            <div className="analog-clock-container w-full h-[200px] flex justify-center items-center mt-2.5">
                <AnalogClock time={time} />
            </div>
          </div>

          {/* Right Column: Other Clocks List */}
          <div className="clock-right-column flex-1.2 border-l border-[rgba(255,255,255,0.1)] pl-[30px] max-[767px]:border-l-0 max-[767px]:border-t max-[767px]:border-[rgba(255,255,255,0.1)] max-[767px]:pl-0 max-[767px]:pt-5">
              <div className="locations-list relative z-[1] pt-5">
                <div className="locations-header text-[1rem] tracking-[2px] mb-[15px] opacity-90">LOCATIONS</div>
                <div className="locations-grid flex flex-col gap-3">
                    {worldLocations.map((loc, index) => {
                    const locTime = time.clone().tz(loc.zone);
                    const offset = locTime.utcOffset() / 60;
                    const nativeOffset = time.utcOffset() / 60;
                    const diff = offset - nativeOffset;
                    const diffStr = diff === 0 ? "+0HRS" : diff > 0 ? `+${diff}HRS` : `${diff}HRS`;

                    // Get Country Name from static JSON if label isn't sufficient
                    const countryName = (timezoneMeta[loc.code] && timezoneMeta[loc.code].name) || loc.label;

                    const locDate = locTime.format('ddd, MMM D');

                    return (
                        <div key={index} className="location-item flex flex-col pb-3 border-b border-[rgba(255,255,255,0.1)] last:border-b-0 last:pb-0">
                            {/* First Line: City Left, Time Right */}
                            <div className="location-row primary-row flex justify-between items-center w-full mb-1">
                                <span className="location-name font-[700] text-[1rem] text-white tracking-[0.5px]">{loc.label.toUpperCase()}</span>
                                <span className="location-time font-[700] text-[1rem] tracking-[1px] text-white flex items-baseline gap-0.5">{formatTimeWithSecondsSmall(locTime)}</span>
                            </div>

                            {/* Second Line: Country Left, Diff + Date Right */}
                            <div className="location-row secondary-row flex justify-between items-center w-full opacity-70">
                                 <div className="country-container flex items-center gap-1.5">
                                     <img
                                        src={`https://flagcdn.com/24x18/${loc.code.toLowerCase()}.png`}
                                        alt={loc.code}
                                        className="country-flag h-3 w-auto rounded-sm opacity-80"
                                     />
                                     <span className="location-country text-[0.75rem] uppercase tracking-[1px]">{countryName.toUpperCase()}</span>
                                 </div>
                                 <span className="location-meta flex gap-2 text-[0.75rem] items-center">
                                    <span className="location-diff bg-[rgba(255,255,255,0.1)] px-1.5 py-0.5 rounded text-[0.7rem]">{diffStr}</span>
                                    <span className="location-date-small uppercase">{locDate}</span>
                                 </span>
                            </div>
                        </div>
                    );
                    })}
                </div>
              </div>
          </div>
      </div>
    </div>
  );
};

export default WorldClock;
